import { useCallback, useState } from 'react';
import { store } from 'redux/store';
import { setFilename } from 'redux/reducers/meteorologyAgroCultureIndexAreaReducer';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import useMapData from './useMapData';

export default function useMapDownload() {
  const [onDownloadClick, setOnDownloadClick] = useState<() => void>(() => () => {});
  const { triggerMapDataRequest } = useMapData();

  const setMapFilename = (areaMap: CultureIndexAreaMap) => {
    const {
      culture, forecastDate, periodStart, periodEnd, stage,
    } = areaMap.params;

    if (Object.values(areaMap.params).some((param) => param === undefined)) {
      store.dispatch(setFilename({
        id: areaMap.id,
        filename: '',
      }));
    } else {
      store.dispatch(setFilename({
        id: areaMap.id,
        filename: `${culture?.label}_${forecastDate}_${periodStart}_${periodEnd}_${stage?.label}_map.png`,
      }));

      // Dispara a requisição da API
      triggerMapDataRequest(areaMap);
    }
  };

  const isDownloadDisabled = useCallback(
    (areaMap: CultureIndexAreaMap) => areaMap.filename === '' || areaMap.data === undefined,
    [],
  );

  return {
    onDownloadClick,
    setOnDownloadClick,
    setMapFilename,
    isDownloadDisabled,
  };
}
